<template>
  <TextInput
    v-model.number="substitutesCount"
    v-validate="'required|numeric'"
    class="hide-arrows-wrapper w-auto substitutes-count-input"
    data-vv-name="substitutesCount"
    :error="errors.first('substitutesCount')"
    :disabled="isTournamentFieldDisabled('max_substitutes') || isButtonDisabled"
    type="number"
    size="3"
    required
    :label="$t('_web_tournament_substitutes-count', 'Qty of substitutes:')"
    :placeholder="
      $$t('Provide a valid qty of substitutes', 'substitutes-count-placeholder')
    "
    :data-vv-as="$$t('Qty of substitutes:', 'substitutes-count-label')"
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import TextInput from '@/components/atoms/form/HeraFormTextInput';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentSubstitutesSetting',
  inject: ['$validator'],
  components: {
    TextInput,
  },
  mixins: [translate('_web_tournament_settings')],
  computed: {
    ...mapGetters(['currentTournament', 'isTournamentFieldDisabled']),
    substitutesCount: {
      get() {
        return this.$lodash.get(
          this.currentTournament,
          'players_config.max_substitutes',
          0
        );
      },
      set(val) {
        this.updateCurrentTournament({
          substitutes: !!val,
          max_substitutes: val,
          component: 'players_config',
        });
      },
    },
    isButtonDisabled() {
      const squadSize = this.$lodash.get(
        this.currentTournament,
        'players_config.squad_size',
        0
      );

      return squadSize < 2;
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
  },
};
</script>

<style lang="scss">
.substitutes-count-input {
  input {
    max-width: 55px;
  }
}
</style>
